{
  "es": {
    "installment_term": {
      "actions": {
        "addUnits": "Unidades",
        "add_fraction": "Añadir fracción",
        "create": "Crear",
        "create_and_share": "Crear y compartir con el cliente",
        "create_price_term": "Nueva regla",
        "delete": "Eliminar",
        "deleteMultiple": "Eliminar...",
        "delete_cancel": "Cancelar",
        "edit": "Editar",
        "newInstallment": "Grupo de cuotas",
        "only_create": "Solo crear",
        "publish_customer": "Publicar para el cliente",
        "selectAll": "Seleccionar las {total} cuotas",
        "selectOne": "Seleccionar una cuota",
        "take": "Cobrar"
      },
      "attributes": {
        "description": "Descripción",
        "installments_count": "{count} cuota | {count} cuotas",
        "name": "Título"
      },
      "labels": {
        "addAllSurcharges": "Todas las mejoras actuales",
        "addAllUnitsPrices": "Todos los precios de las unidades",
        "amount": "Importe de la cuota",
        "balanceFractionTypes": "Tipos de fracción del saldo",
        "balanceTotal": "Saldo total",
        "containsSurcharges": "Incluye mejoras",
        "create_decision_first": "Esta opción estará disponible en cuanto crees una decisión.",
        "deleteInstallmentTerm": "Eliminar grupo de cuotas",
        "description": "Descripción",
        "documents": "Documentos",
        "duplicate_price_type": "Ya existe una fracción con este tipo de precio.",
        "editInstallmentTerm": "Editar grupo de cuotas",
        "edit_description": "Editar descripción",
        "fixed": "Fijo",
        "fixedAmount": "Importe fijo de",
        "for": "para",
        "forEachUnit": "de cada unidad",
        "fraction_types": {
          "absolute": "Importe fijo",
          "relative": "Porcentaje"
        },
        "goToAmounts": "Seleccionar importes",
        "installments": "Finanzas",
        "installmentsTitle": "Cuota",
        "installments_all_projects": "Finanzas de todos los proyectos",
        "invalidAmount": "Importe no válido",
        "list": "Lista",
        "name": "Grupo de cuotas n.º {count}",
        "noContainsSurcharges": "No incluye mejoras",
        "noInstallmentsToPay": "No hay cuotas pendientes",
        "noUnitsClick": "Todavía no hay unidades, haz clic aquí para añadir",
        "ofThe": "de la",
        "price_types": {
          "custom_amount": "Otro",
          "price_value": "Valor total",
          "price_value_construction": "Valor de construcción",
          "price_value_construction_existing": "Costes de construcción existente",
          "price_value_fees": "Honorarios de arquitectura/ingeniería",
          "price_value_land": "Valor del suelo",
          "surcharge": "Mejoras",
          "unit": "Precios de las unidades"
        },
        "projectUnitsTotal": "{project_name} tiene {units_count_max} unidades en total",
        "publish_now": "¿Publicar ahora?",
        "rules": "Reglas de pago",
        "rules_subtitle": "Define qué porcentaje o importe se cobra",
        "save_explainer": "¿Hacer visible este grupo de cuotas para tus clientes? ¿O guardarlo y publicarlo más tarde?",
        "selectUnits": "Seleccionar unidades",
        "selected": "{selected} cuota seleccionada. | {selected} cuotas seleccionadas.",
        "shortcuts": "Accesos directos",
        "show_installment_terms_for": "Mostrar cuotas de",
        "step1Info": "Añade una descripción",
        "step2Subtitle": "Selecciona tu proyecto para incluir todas tus unidades a la vez.",
        "step2Title": "¿Qué unidades están relacionadas con esta cuota?",
        "surcharges": "Mejoras",
        "total": "Total",
        "totalFixed": "Total fijo",
        "totalPaid": "Total pagado",
        "totalRequested": "Total facturado",
        "totalSelected": "Se han seleccionado las {total} cuotas.",
        "totalSurcharges": "Total de mejoras",
        "totalUnpaid": "Total pendiente",
        "unitSelected": "Todavía no hay ninguna unidad seleccionada | Una unidad seleccionada | {count} unidades seleccionadas",
        "units": "Unidades"
      },
      "navigation": {
        "backToInstallmentTerms": "Volver a la vista general de grupos de cuotas"
      },
      "placeholders": {
        "amount": "Selecciona un importe fijo o un porcentaje del valor de la unidad o de las mejoras",
        "description": "P. ej. 10 % - Después de verter la losa de hormigón de la primera planta...",
        "due_date": "Indica la fecha antes de la cual debe pagarse la cuota",
        "employees": {
          "new": {
            "subtitle": "Añade cuotas y haz seguimiento de su estado",
            "title": "Crea una vista general financiera"
          }
        },
        "installmentTermFractionNotice": "Los importes de las cuotas ya no se pueden ajustar porque algunas cuotas ya se han entregado al comprador",
        "name": "P. ej. Grupo de cuotas n.º 1, Grupo de cuotas - Mejoras",
        "summary": "Resumen",
        "surcharge": "mejora"
      },
      "toasts": {
        "bulk_create": "Cuota creada correctamente | Cuotas creadas correctamente",
        "bulk_delete": "Cuota eliminada correctamente | Cuotas eliminadas correctamente",
        "bulk_update": "Cuota actualizada correctamente | Cuotas actualizadas correctamente",
        "delete": "Cuota eliminada correctamente",
        "update": "Cuota actualizada correctamente"
      },
      "validation": {
        "fixedFractionLabel": "{price_type} ya se ha combinado con {fraction_type} en otra cuota existente. Solo se permite {fraction_type} para mantener la coherencia.",
        "maxLengthName": "El nombre es demasiado largo",
        "needDescription": "La descripción es obligatoria",
        "needInstallmentTermFraction": "Se requiere un precio del grupo",
        "needName": "El nombre es obligatorio",
        "needUniquePricesTypes": "Las reglas no pueden tener el mismo tipo de precio dentro de un grupo de cuotas",
        "needValidTerm": "El importe no puede ser 0 y el tipo de precio debe existir",
        "selectInstallmentTerm": "Selecciona al menos 1 cuota",
        "selectUnit": "Selecciona al menos 1 unidad"
      }
    }
  }
}
